export const RESIZE_BOX_PADDING = 1.5;

export const INACTIVE_WORD_OPACITY = 0.6;
export const CAPTION_HORIZONTAL_SPACE_FACTOR = 0.1875;

export const INITIAL_CAPTIONS_TOP_MARGIN_PERCENTAGE = 1;
